import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AppConstants } from 'src/app-constants';
import { AccountService } from 'src/app/services/account.service';
import { CommonService } from 'src/app/services/common.service';
import { LogHandlerService } from 'src/app/services/log-handler.service';
import { SignUpViewModel } from 'src/app/view-models/sign-up.viewmodel';
import { BaseComponent } from '../base.component';


@Component({
  selector: 'app-sign-up',
  templateUrl: './sign-up.component.html',
  styleUrls: ['./sign-up.component.scss']
})
export class SignUpComponent extends BaseComponent<SignUpViewModel> implements OnInit {


  constructor(private commonService: CommonService,
    private logService: LogHandlerService,
    public activeModal: NgbActiveModal,
    private accountService: AccountService,
    private router: Router) {
    super(commonService, logService);
    this.viewModel = new SignUpViewModel();
  }
  ngOnInit() {

  }
  async click_showLoginModal() {
    this.router.navigate([AppConstants.WebRoutes.Home])
    var x = await this._commonService.presentLoginModal();
    this._exceptionHandler.logObject(x);

  }

  async click_SignUp() {
    // this.viewModel.isFormSubmitted = true;
    //     this.activeModal.close(true);
    // return;
    try {
      if (!this.submit())
        return;

      await this._commonService.presentLoading();
      //have to do paging
      let resp = await this.accountService.registerUser(this.viewModel.userDetails);
      if (resp.isError) {
        this._exceptionHandler.logObject(resp.errorData);
        this._commonService.presentToast({
          header: 'Error!',
          body: resp.errorData.displayMessage, delay: 5000,
          className: 'TopRight bg-danger text-light', animation: true
        });
      }
      else {
        this.activeModal.close(true);
         if (resp != null)
          this.router.navigate([AppConstants.WebRoutes.Home]);
      }
    } catch (error) {
      this._commonService.presentToast({
        header: 'Error!',
        body: AppConstants.ErrorPrompts.Unknown_Error, delay: 5000,
        className: 'TopRight bg-danger text-light', animation: true
      });
      throw error;
    }
    finally {
      await this._commonService.dismissLoader()
    }
  }


  submit(): any {
    let formValid = true;
    // this.viewModel.removeValidationErrors();

    // if (this.viewModel.userDetails.firstName == undefined || this.viewModel.userDetails.firstName == '') {
    //   this.viewModel.setValidationError('firstName', ErrType.Required);
    //   formValid = false;
    // }
    // if (this.viewModel.userDetails.lastName == undefined || this.viewModel.userDetails.password == '') {
    //   this.viewModel.setValidationError('lastName', ErrType.Required);
    //   formValid = false;
    // }
    // if (this.viewModel.userDetails.email == undefined || this.viewModel.userDetails.email == '') {
    //   this.viewModel.setValidationError('email', ErrType.Required);
    //   formValid = false;
    // }
    // if (this.viewModel.userDetails.contact == undefined || this.viewModel.userDetails.password == '') {
    //   this.viewModel.setValidationError('contact', ErrType.Required);
    //   formValid = false;
    // }
    // if (this.viewModel.userDetails.password == undefined || this.viewModel.userDetails.password == '') {
    //   this.viewModel.setValidationError('password', ErrType.Required);
    //   formValid = false;
    // }

    // alert(JSON.stringify(this.viewModel.validationMessages))
    return formValid;

  }



}




